import * as Yup from 'yup';

import { createLocale } from 'locales';

const globalLocalize = createLocale('global');

export default Yup.object().shape({
  certificates: Yup.array(),
  competence: Yup.string().required(
    globalLocalize('fieldRequiredErrorMessage'),
  ),
  location: Yup.number()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .min(1, globalLocalize('fieldRequiredErrorMessage')),
  max_rate: Yup.number()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .min(30)
    .max(99),
  max_rate_exempt: Yup.number()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .min(30)
    .max(99),
  pause: Yup.number()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .min(0)
    .max(90),
});
